<script setup lang="ts">
const featureRequestBody = `Bonjour l'équipe Apodis,

Je souhaiterais vous faire part d'une suggestion pour améliorer mon quotidien :

[Décrivez votre suggestion ici]

Merci d'avance pour votre travail et votre écoute.

Cordialement.
[Votre nom]
[Votre pharmacie]`;

const featureRequestMailto = `mailto:contact@apodispharma.com?subject=${encodeURIComponent('Suggestions de fonctionnalité pour Apodis')}&body=${encodeURIComponent(featureRequestBody)}`;
</script>

<template>
  <div>
    <p>
      Une idée pour améliorer votre quotidien avec Apodis ? Partagez vos suggestions, nous sommes à l'écoute !
    </p>
    <p>
      Envoyez-nous vos suggestions :
      <a
        class="text-primary underline"
        :href="featureRequestMailto"
      >
        contact
      </a>
    </p>
  </div>
</template>

<style scoped>
</style>
